import React from "react";

/**
 * Safe JSON-LD <script> renderer.
 *
 * Why it's needed: `dangerouslySetInnerHTML` with `JSON.stringify(data)` can
 * theoretically allow injection if any string in `data` contains `</script>`
 * or other HTML-significant chars. We escape:
 *   - "<"      -> "\u003C"   (prevents </script>, <!--, <script>)
 *   - "u2028"  -> "\u2028"   (line separator, JS parser eats it)
 *   - "u2029"  -> "\u2029"   (paragraph separator)
 *
 * This pattern is the long-standing standard for inlining JSON safely
 * (used by Next.js, react-helmet, react-schemaorg, etc.).
 */
const ESCAPE_LOOKUP = {
  "<": "\\u003c",
  "\u2028": "\\u2028",
  "\u2029": "\\u2029",
};
const ESCAPE_RE = /[<\u2028\u2029]/g;

function safeStringify(value) {
  return JSON.stringify(value).replace(ESCAPE_RE, (m) => ESCAPE_LOOKUP[m]);
}

export default function JsonLd({ data }) {
  if (!data) return null;
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeStringify(data) }}
    />
  );
}
